module.exports = __webpack_public_path__ + "static/media/roseChatPopup.1fc88c6b.png";